import { Systems } from "./systems";

export enum FHIRValueSets {
  AllergyIntoleranceCode = `${Systems.FHIR_VS}/allergyintolerance-code`,
  AllergyIntoleranceClinicalStatus = `${Systems.FHIR_VS}/allergyintolerance-clinical`,
  ReactionManifestation = `${Systems.FHIR_VS}/clinical-findings`,
  ReactionSeverity = `${Systems.FHIR_VS}/reaction-event-severity`,
  ConditionClinicalStatus = `${Systems.FHIR_VS}/condition-clinical`,
  MedicationCode = `${Systems.FHIR_VS}/medication-codes`,
  MedicationStatus = `${Systems.FHIR_VS}/medication-status`,
  Language = `${Systems.FHIR_VS}/languages`,
  PolicyRule = `${Systems.FHIR_TERMINOLOGY}/consent-policy`,
  ConsentScope = `${Systems.FHIR_TERMINOLOGY}/consent-scope`,
  USStates = `${Systems.FHIR_US_COMMON_LIBRARY}/ValueSet-states-territories-provinces-vr`,
  Relationship = `${Systems.FHIR_VS}/relationship`,
  ContactPointUse = `${Systems.FHIR_VS}/contact-point-use`,
  Iso3166_1_2 = `${Systems.FHIR_VS}/iso3166-1-2`,
  USCoreUspsState = `${Systems.HL7USCoreValueSet}/us-core-usps-state`,
  SignatureType = `${Systems.FHIR_VS}/signature-type`,
  Timezone = `${Systems.FHIR_VS}/timezones`,
  ConditionCategory = `${Systems.FHIR_VS}/condition-category`,
  ObservationCategory = `${Systems.FHIR_VS}/observation-category`,
  AdmissionType = `${Systems.LOINC}/vs/LL3652-6`,
  DischargeDisposition = `${Systems.LOINC}/vs/LL2766-5`,
  FacilityAdmissionSource = `${Systems.QH}/fhir/ValueSet/qh-facility-admission-source`,
}

export enum DataOperation {
  Operate = "OPERATE",
  Create = "CREATE",
  Delete = "DELETE",
  Execute = "EXECUTE",
  Read = "READ",
  Update = "UPDATE",
  Append = "APPEND",
  ModifyStatus = "MODIFYSTATUS",
  Abort = "ABORT",
  Activate = "ACTIVATE",
  Cancel = "CANCEL",
  Complete = "COMPLETE",
  Hold = "HOLD",
  Jump = "JUMP",
  Nullify = "NULLIFY",
  Obsolete = "OBSOLETE",
  Deprecate = "DEPRECATE",
  Reactivate = "REACTIVATE",
  Release = "RELEASE",
  Resume = "RESUME",
  Suspend = "SUSPEND",
}

export enum ProvenanceParticipantType {
  Enterer = "enterer",
  Performer = "performer",
  Author = "author",
  Verifier = "verifier",
  Legal = "legal",
  Attester = "attester",
  Informant = "informant",
  Custodian = "custodian",
  Assembler = "assembler",
  Composer = "composer",
}

export enum SignatureType {
  AuthorsSignature = "1.2.840.10065.1.12.1.1",
  CoauthorsSignature = "1.2.840.10065.1.12.1.2",
  CoparticipantsSignature = "1.2.840.10065.1.12.1.3",
  TranscriptionistRecorderSignature = "1.2.840.10065.1.12.1.4",
  VerificationSignature = "1.2.840.10065.1.12.1.5",
  ValidationSignature = "1.2.840.10065.1.12.1.6",
  ConsentSignature = "1.2.840.10065.1.12.1.7",
  SignatureWitnessSignature = "1.2.840.10065.1.12.1.8",
  EventWitnessSignature = "1.2.840.10065.1.12.1.9",
  IdentityWitnessSignature = "1.2.840.10065.1.12.1.10",
  ConsentWitnessSignature = "1.2.840.10065.1.12.1.11",
  InterpreterSignature = "1.2.840.10065.1.12.1.12",
  ReviewSignature = "1.2.840.10065.1.12.1.13",
  SourceSignature = "1.2.840.10065.1.12.1.14",
  AddendumSignature = "1.2.840.10065.1.12.1.15",
  ModificationSignature = "1.2.840.10065.1.12.1.16",
  AdministrativeErrorEditSignature = "1.2.840.10065.1.12.1.17",
  TimestampSignature = "1.2.840.10065.1.12.1.18",
}

export enum OrganizationType {
  HealthCareProvider = "prov",
  Facility = "F",
  InsuranceCompany = "ins",
  CustomInsurance = "custom-insurance",
}

export const OrganizationTypeDisplay = {
  [OrganizationType.HealthCareProvider]: "Healthcare Provider",
  [OrganizationType.Facility]: "Facility",
  [OrganizationType.InsuranceCompany]: "Insurance Company",
  [OrganizationType.CustomInsurance]: "Custom Insurance",
} as const;

/** Placeholder resource id used by creatable questionnaire reference fields. */
export enum CreatableReferenceId {
  Custom = "custom",
}

export enum OrganizationRole {
  Diagnostics = "diagnostics",
}

export enum ConditionClinicalStatus {
  ProblemListItem = "problem-list-item",
  EncounterDiagnosis = "encounter-diagnosis",
}

export enum ObservationCategory {
  VitalSigns = "vital-signs",
  Laboratory = "laboratory", // Exclusive for Health Gorilla
}

export enum V3ActCode {
  HealthInsurancePolicy = "HIP",
}

export enum CoverageClassCode {
  Group = "group",
}

export enum DiagnosticServiceSectionID {
  Laboratory = "LAB",
}

export enum IdentifierType {
  AccountNumber = "AN",
}

/** ISO 639-1 language codes used for patient communication entries. */
export enum LanguageCode {
  English = "en",
}
